import getConfig from 'next/config';
import React from 'react';
import { AnalyticsHelper } from '@/utilities/AnalyticsHelper';
import { AnalyticsEventName, CtaText, ScreenName } from '@/types/enums';

import { VERTICALS_NAMES, LIST_YOUR_BUSINESS_LINKS } from '@/constants';

const {
  publicRuntimeConfig: { CZEN_GENERAL },
} = getConfig();

export type GridElementHandlerProps = {
  careOrgProp: React.Dispatch<React.SetStateAction<boolean>>;
  listYourBusinessProp: 'VHP Header' | 'VHP Footer';
};

export const handleListYourBusinessClick = (
  e: React.MouseEvent<HTMLElement>,
  ctaLocaton?: string
) => {
  const element = e.target as HTMLElement;
  const clickedLinkText = element.textContent?.trim();

  const clickedLink = [
    ...LIST_YOUR_BUSINESS_LINKS,
    // there is still one button in the SocialIconsMW, keeping this to handle unit test
    { label: 'List your business', address: '/app/pn-business' },
  ].find((link) => link.label === clickedLinkText);
  if (clickedLink) {
    e.preventDefault();

    AnalyticsHelper.logEvent({
      name: AnalyticsEventName.CTA_INTERACTED_VHP,
      data: {
        screen_name: ScreenName.VISITOR_HOMEPAGE,
        enrollment_initiated: false,
        cta_text: clickedLink.label as CtaText,
        cta_location: ctaLocaton ?? 'VHP Footer',
        vertical: VERTICALS_NAMES.unknown,
      },
    });

    window.location.assign(`${CZEN_GENERAL}${clickedLink.address}`);
  }
};

const handleCareOrgClick = (
  e: React.MouseEvent<HTMLElement>,
  careOrgProp?: React.Dispatch<React.SetStateAction<boolean>>
) => {
  if (!careOrgProp) return;

  e.preventDefault();

  careOrgProp(true);
};

export const handleGridElementClick = (
  e: React.MouseEvent<HTMLElement>,
  gridElementHandlerProps?: GridElementHandlerProps
) => {
  const element = e.target as HTMLElement;
  const text = element.textContent?.trim();

  const { careOrgProp, listYourBusinessProp } = gridElementHandlerProps ?? {};

  const handlers: Record<
    string,
    (e: React.MouseEvent<HTMLElement>, gridElementHandlerProps?: GridElementHandlerProps) => void
  > = {
    'Care.org': () => handleCareOrgClick(e, careOrgProp),
    'List your activity / camps center': () => handleListYourBusinessClick(e, listYourBusinessProp),
    'List your business': () => handleListYourBusinessClick(e, listYourBusinessProp),
    'List your early learning center': () => handleListYourBusinessClick(e, listYourBusinessProp),
    'List your senior living community': () => handleListYourBusinessClick(e, listYourBusinessProp),
  };

  if (text && handlers[text] && gridElementHandlerProps) {
    handlers[text](e, gridElementHandlerProps);
  } else if (text && handlers[text]) {
    handlers[text](e);
  }
};
